var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanada({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 7.24247 21.2313 3.13172 17.2174 1.19072V22.8092C21.2313 20.8683 24 16.7575 24 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 16.7575 2.76867 20.8683 6.78263 22.8093V1.19072C2.76867 3.13172 0 7.24247 0 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.087 13.5652L16.1739 12.5217L15.1305 12V10.9565L13.0435 12L14.087 9.91303H13.0435L12 8.34782L10.9565 9.91303H9.91303L10.9565 12L8.86955 10.9565V12L7.82611 12.5217L9.91303 13.5652L9.39131 14.6087H11.4783V16.1739H12.5217V14.6087H14.6087L14.087 13.5652Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/canada.042770c107216482c848abf67795dce2.svg";
export { ForwardRef as ReactComponent };